import type { WorkflowGraphApiData } from './workflow-graph.types';
import type { WorkflowNodeViewData } from './components/node/types';

export function graphNodeToViewData(
  node: WorkflowGraphApiData['nodes'][number]
): WorkflowNodeViewData {
  return {
    id: node.id,
    type: node.type,
    data: node.data,
    inputShape: node.inputShape,
    defaultOutput: node.defaultOutput,
  };
}
